import React from 'react';
import useConfirm from '../../hooks/useConfirm';
import { Button, Group, Text, Modal } from '@mantine/core';

const ConfirmDialog = () => {
	const { onConfirm, onCancel, confirmState } = useConfirm();

	return (
		<Modal
			opened={confirmState.show}
			onClose={onCancel}
			title="Delete Confirmation"
		>
			<Text size="md" c="dimmed">
				{confirmState?.text ? confirmState.text : ''}
			</Text>
			<Group mt="md" gap="xs" align="center" justify="flex-end">
				<Button variant="filled" onClick={onConfirm}>
					Yes
				</Button>
				<Button variant="outline" color="red" onClick={onCancel}>
					No
				</Button>
			</Group>
		</Modal>
	);
};
export default ConfirmDialog;
